import { ModuleWithProviders, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FeatureService, FeatureServiceConfig } from './feature.service';
import { FeaturePipe } from './feature.pipe';
import { featureFactory } from './feature.factory';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [CommonModule],
  declarations: [FeaturePipe],
  exports: [FeaturePipe],
})
export class FeatureModule {
  constructor(@Optional() @SkipSelf() parentModule?: FeatureModule) {
    if (parentModule) {
    }
  }

  static forRoot(
    config: FeatureServiceConfig
  ): ModuleWithProviders<FeatureModule> {
    return {
      ngModule: FeatureModule,
      providers: [
        { provide: FeatureServiceConfig, useValue: config },
        FeatureService,
        provideAppInitializer(() => {
        // @ts-ignore
          const initializerFn = (featureFactory)(inject(FeatureService), inject(HttpClient));
        return initializerFn();
      }),
      ],
    };
  }
  static forChild(
    config: FeatureServiceConfig
  ): ModuleWithProviders<FeatureModule> {
    return {
      ngModule: FeatureModule,
      providers: [
        { provide: FeatureServiceConfig, useValue: config },
        FeatureService,
        provideAppInitializer(() => {
        // @ts-ignore
          const initializerFn = (featureFactory)(inject(FeatureService), inject(HttpClient));
        return initializerFn();
      }),
      ],
    };
  }
}
